import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import * as Actions from '../navigation/actions';
import styles from './styles.module.scss';

/**
 * Component to display when there's an email mismatch for an invite
 */
const EmailMismatchMessage = ({ currentEmail, signOut }) => {
  // Get the invite code from URL params
  const { inviteCode } = useParams();
  
  // Handle logout with invite code for redirect
  const handleSignOut = () => {
    signOut(inviteCode);
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>Wrong Account</h2>
        <div className={styles.mismatchError}>
          <p>This invitation was sent to another user</p>
          <p>You are currently logged in with {currentEmail || 'a different email account'}</p>
        </div>
        
        <p className={styles.message}>
          To claim this athlete profile, you need to log in with the email address that received the invitation.
        </p>
        
        <div className={styles.buttonContainer}>
          <button 
            onClick={handleSignOut}
            className={styles.button}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    signOut: Actions.signOut,
  }, dispatch);
};

export default connect(null, mapDispatchToProps)(EmailMismatchMessage);
